import lodash from "lodash";
import { Rectangle, Vector2 } from "../math";
export var ScreenRectangle;
(function (ScreenRectangle) {
    function move(rect, offset, new_size = null) {
        return {
            origin: Vector2.add(rect.origin, offset),
            size: new_size ?? rect.size
        };
    }
    ScreenRectangle.move = move;
    function subRect(rect, sub) {
        return move(rect, sub.origin, sub.size);
    }
    ScreenRectangle.subRect = subRect;
    function relativeTo(parent, child) {
        return {
            origin: Vector2.sub(child.origin, parent.origin),
            size: child.size,
        };
    }
    ScreenRectangle.relativeTo = relativeTo;
    function fromRectangle(rect) {
        return {
            origin: Rectangle.screenOrigin(rect),
            size: {
                x: Rectangle.width(rect) + 1,
                y: Rectangle.height(rect) + 1,
            }
        };
    }
    ScreenRectangle.fromRectangle = fromRectangle;
    function fromPixels(...pixels) {
        return fromRectangle(Rectangle.from(...pixels));
    }
    ScreenRectangle.fromPixels = fromPixels;
    function toRectangle(rect) {
        return Rectangle.fromOriginAndSize(rect.origin, rect.size);
    }
    ScreenRectangle.toRectangle = toRectangle;
    function extend(rect, offset) {
        return {
            origin: Vector2.sub(rect.origin, offset),
            size: Vector2.add(rect.size, offset, offset),
        };
    }
    ScreenRectangle.extend = extend;
    function contains(rect, pos) {
        const off = Vector2.sub(pos, rect.origin);
        return off.x >= 0 && off.x < rect.size.x && off.y >= 0 && off.y < rect.size.y;
    }
    ScreenRectangle.contains = contains;
    function center(rect) {
        return Vector2.snap(Vector2.add(rect.origin, Vector2.scale(0.5, rect.size)));
    }
    ScreenRectangle.center = center;
    function centeredOn(center, radius) {
        if (typeof radius == "number")
            radius = { x: radius, y: radius };
        return {
            origin: Vector2.sub(center, radius),
            size: Vector2.scale(2, radius)
        };
    }
    ScreenRectangle.centeredOn = centeredOn;
    function union(...rects) {
        return ScreenRectangle.fromRectangle(Rectangle.union(...rects.map(ScreenRectangle.toRectangle)));
    }
    ScreenRectangle.union = union;
    function equals(a, b) {
        return lodash.isEqual(a, b);
    }
    ScreenRectangle.equals = equals;
})(ScreenRectangle || (ScreenRectangle = {}));
